import React from 'react'

import './_close-button.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import closeIcon from '../../assets/icons/close.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'button'>,
  {
    size?: 'default' | 'l'
    invert?: boolean
    onClick?: React.MouseEventHandler
    title?: string
  }
>

const CloseButton = ({
  className,
  size = 'default',
  invert = false,
  title,
  onClick,
  ...props
}: Props) => (
  <button
    {...props}
    type="button"
    className={cn('CloseButton', {invert, [`size-${size}`]: true}, className)}
    onClick={onClick}
  >
    <Icon block source={closeIcon} title={title} />
  </button>
)

export default CloseButton
